
import DnButton from '@digitalnatives/button';

export default {
    components: {
        DnButton
    }
};
